import { render, staticRenderFns } from "./ModeloSearchView.vue?vue&type=template&id=dfbb16fa&scoped=true"
import script from "./ModeloSearchView.vue?vue&type=script&lang=js"
export * from "./ModeloSearchView.vue?vue&type=script&lang=js"
import style0 from "./ModeloSearchView.vue?vue&type=style&index=0&id=dfbb16fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfbb16fa",
  null
  
)

export default component.exports